<template>
	<span v-if="data === '' || data === null"></span>
	<span v-else>
		<font-awesome-icon icon="clock" :id="tooltipId" class="timestamp" v-if="icon && !full" />
		{{ full ? fullTimestamp : humanTimestamp }}
		<b-tooltip :target="tooltipId" triggers="hover" v-if="icon && !full">
			{{ timestamp }}
		</b-tooltip>
	</span>
</template>

<script>
import moment from 'moment-timezone';
import { v4 as uuidv4 } from 'uuid';

export default {
	props: {
		data: {
			required: true
		},
		format: {
			default: 'dddd, MMMM Do YYYY, h:mm:ss a'
		},
		full: {
			type: Boolean,
			default: true
		},
		fullFormat: {
			default: 'MM/DD/YYYY hh:mm:ss a'
		},
		icon: {
			type: Boolean,
			default: true
		},
		timezone: {
			type: String
		}
	},

	computed: {
		tooltipId () {
			return uuidv4();
		},

		humanTimestamp () {
			return this.momentDate.calendar(null, { sameElse: this.fullFormat });
		},

		timestamp () {
			return this.momentDate.format(this.format);
		},

		fullTimestamp () {
			return `${this.momentDate.format(this.fullFormat)} ${moment.tz.zone(this.zone).abbr(this.momentDate)}`;
		},
		momentDate () {
			return moment.utc(this.data).tz(this.zone);
		},
		zone () {
			return this.timezone ? this.timezone : moment.tz.guess();
		}
	}
};
</script>
